/**
 * Shared activity event label and color mappings.
 *
 * Used by both ProjectOverviewSidebar and the Activity tab in ProjectDetails
 * to convert raw event names (e.g. `database_ready`) into human-readable
 * labels (e.g. "Database ready").
 */

export const ACTIVITY_EVENT_LABELS: Record<string, string> = {
  provisioning_started: "Provisioning started",
  vault_secret_written: "Vault secret written",
  gitops_committed: "GitOps manifest committed",
  database_ready: "Database ready",
  external_secret_ready: "External secret ready",
  provisioning_failed: "Provisioning failed",
  provisioning_retried: "Provisioning retried",
  resource_deprovisioned: "Resource deprovisioned",
};

/** Convert a raw event name to a human-readable label. */
export function activityLabel(event: string): string {
  return ACTIVITY_EVENT_LABELS[event] ?? event;
}

/** Determine the semantic color for an activity dot. */
export function activityDotColor(event: string): string {
  if (event === "provisioning_failed" || event === "resource_deprovisioned") {
    return "error.main";
  }
  if (event === "database_ready" || event === "external_secret_ready") {
    return "success.main";
  }
  return "text.secondary";
}
